import axios from "axios";
import { useEffect } from "react";
import { apiUrl } from "../config/settings";
import { useDispatch, useSelector } from "react-redux";
import { LANGUAGES_LIST } from "../config/const";
import { setShowLoading } from "../store/sysSlice";
import { useNavigate, useParams } from "react-router-dom";
import { setBizData } from "../store/cardSlice";
import usePwa from "../hooks/usePwa";

const ApiProvider = ({ children }) => {
  const navigate = useNavigate();
  const { pwaConected } = usePwa()
  const dispatch = useDispatch();
  const { bizPath, miniSitePath } = useParams();

  const langType = useSelector((state) => state?.userSettings?.selectedLang);
  document.dir = LANGUAGES_LIST.find((lang) => lang.id === langType)?.dir;

  useEffect(() => {
    if (bizPath && miniSitePath) {
      dispatch(setShowLoading(true));
      axios.get(`${apiUrl}/miniSite/${bizPath}/${miniSitePath}`)
        .then((response) => {
          if (response.status === 200) {
            axios.defaults.headers.common["BizId"] = `${response?.data?.biz?.id}`;
            dispatch(setBizData(response?.data));
          }
          dispatch(setShowLoading(false));
        })
        .catch((error) => {
          navigate("/");
          console.error("Auth error");
          dispatch(setShowLoading(false));
        });
    }
  }, [miniSitePath, bizPath]);

  useEffect(() => {
    addDynamicManifest()
    pwaConected()
  }, []);

  const addDynamicManifest = async () => {
    const manifestLink = document.createElement("link");
    manifestLink.rel = "manifest";
    manifestLink.href = `${apiUrl}/manifest/${bizPath}/${miniSitePath}`;
    document.head.appendChild(manifestLink);
  };

  return children;
};

export default ApiProvider;
